export const filterCurrencyPairs = (currencyPairs: string[], searchTerm: string) => {
  return currencyPairs.filter(searchTermFilter(searchTerm));
};

const True = () => true;
const False = () => false;

const searchTermFilter = (searchTerm: string) => {
  const normalizedSearchTerm = searchTerm
    .trim()
    .toUpperCase()
    .replace(/\s/, '/') // only first space will be considered equivalent to currency separator
    .replace(/[^A-Z/]/g, '');

  // no search term content : return all currency pairs
  if (normalizedSearchTerm.length === 0) {
    return True;
  }
  // ill formed search term content : return none
  if (normalizedSearchTerm.match(/^\/{2,}$/)) {
    return False;
  }

  const [part1, part2] = normalizedSearchTerm.split('/', 2);

  if (part1 && part2) {
    // the two part may apply to either first ccy either second ccy
    // as abserved on legacy fx
    const ccy1MatchesPart1 = new RegExp(`^${part1}[^/]*/${part2}`);
    const ccy2MatchesPart2 = new RegExp(`^${part2}[^/]*/${part1}`);
    return (currencyPair: string) => ccy1MatchesPart1.test(currencyPair) || ccy2MatchesPart2.test(currencyPair);
  }

  const part = part1 || part2;
  if (part) {
    if (part.length > 3) {
      // for instance "EURU"
      // then will behave like "EUR/U", but EUR matching only currency1 (USD/EUR wont' match)
      return (currencyPair: string) =>
        currencyPair.startsWith(part.slice(0, 3)) && currencyPair.includes(`/${part.slice(3)}`);
    }
    // only one part provided, be in part1 or part2 result in the same behavior
    return (currencyPair: string) => currencyPair.startsWith(part) || currencyPair.includes(`/${part}`);
  }

  return True;
};
